// Opta nationality names → circle-flags codes (public/flags/{code}.svg).
// Unknown names return null and the card draws no flag.
const FLAG_CODES: Record<string, string> = {
  Albania: 'al',
  Algeria: 'dz',
  Angola: 'ao',
  Argentina: 'ar',
  Australia: 'au',
  Austria: 'at',
  Belarus: 'by',
  Belgium: 'be',
  'Bosnia and Herzegovina': 'ba',
  Brazil: 'br',
  Bulgaria: 'bg',
  'Burkina Faso': 'bf',
  Cameroon: 'cm',
  Canada: 'ca',
  'Cape Verde': 'cv',
  'Central African Republic': 'cf',
  Chile: 'cl',
  Colombia: 'co',
  Congo: 'cg',
  'Congo DR': 'cd',
  Croatia: 'hr',
  Curaçao: 'cw',
  Czechia: 'cz',
  "Côte d'Ivoire": 'ci',
  Denmark: 'dk',
  Ecuador: 'ec',
  Egypt: 'eg',
  England: 'gb-eng',
  Estonia: 'ee',
  Finland: 'fi',
  France: 'fr',
  Gambia: 'gm',
  Georgia: 'ge',
  Germany: 'de',
  Ghana: 'gh',
  Greece: 'gr',
  Guadeloupe: 'gp',
  Guinea: 'gn',
  Haiti: 'ht',
  Hungary: 'hu',
  Iceland: 'is',
  Indonesia: 'id',
  Iran: 'ir',
  Israel: 'il',
  Italy: 'it',
  Japan: 'jp',
  'Korea Republic': 'kr',
  Kosovo: 'xk',
  Luxembourg: 'lu',
  Madagascar: 'mg',
  Mali: 'ml',
  Mauritania: 'mr',
  Mexico: 'mx',
  Moldova: 'md',
  Montenegro: 'me',
  Morocco: 'ma',
  Netherlands: 'nl',
  Nigeria: 'ng',
  'North Macedonia': 'mk',
  'Northern Ireland': 'gb-nir',
  Norway: 'no',
  Panama: 'pa',
  Poland: 'pl',
  Portugal: 'pt',
  'Republic of Ireland': 'ie',
  Romania: 'ro',
  'Saudi Arabia': 'sa',
  Scotland: 'gb-sct',
  Senegal: 'sn',
  Serbia: 'rs',
  Singapore: 'sg',
  Slovakia: 'sk',
  Slovenia: 'si',
  'South Africa': 'za',
  Spain: 'es',
  Suriname: 'sr',
  Sweden: 'se',
  Switzerland: 'ch',
  Syria: 'sy',
  Togo: 'tg',
  Tunisia: 'tn',
  Türkiye: 'tr',
  USA: 'us',
  Ukraine: 'ua',
  Uruguay: 'uy',
  Uzbekistan: 'uz',
  Venezuela: 've',
  Wales: 'gb-wls',
  Zimbabwe: 'zw',
};

export const flagUrl = (nationality: string | null | undefined): string | null => {
  const code = nationality ? FLAG_CODES[nationality] : undefined;
  return code ? `/flags/${code}.svg` : null;
};

export const FLAG_CODE_LIST = Object.values(FLAG_CODES);
